import { Copy, ExternalLink, Globe2, Link2, MonitorSmartphone, MoreHorizontal, QrCode, Share2 } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "../../components/ui/PageHeader";
import { useAccount } from "../../context/AccountContext";

export function WebsitePage() {
  const [copied, setCopied] = useState(false);
  const { account } = useAccount();
  const sitesBase = (import.meta.env.VITE_SITES_BASE_URL || "http://localhost:8788").replace(/\/$/, "");
  const siteUrl = account?.site ? `${sitesBase}/${account.site.slug}` : sitesBase;

  const copyUrl = async () => {
    await navigator.clipboard?.writeText(siteUrl);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };

  return (
    <div className="space-y-8">
      <PageHeader
        eyebrow="Website tersinkron"
        title="Kelola website aktif"
        description="Website ini adalah aset yang sama dengan hasil pembuatan melalui WhatsApp. Upgrade tidak membuat salinan baru."
        actions={
          <>
            <button type="button" className="btn-secondary" onClick={copyUrl}><Copy size={17} /> {copied ? "Tersalin" : "Salin link"}</button>
            <a className="btn-primary" href={siteUrl} target="_blank" rel="noreferrer">Buka website <ExternalLink size={17} /></a>
          </>
        }
      />

      <section className="grid gap-5 xl:grid-cols-[1.1fr_0.9fr]">
        <article className="surface overflow-hidden">
          <div className="relative overflow-hidden bg-gradient-to-br from-brand-800 via-brand-900 to-slate-950 p-7 text-white sm:p-9">
            <div className="absolute -right-20 -top-24 h-60 w-60 rounded-full bg-accent-500/25 blur-3xl" />
            <div className="relative flex flex-col gap-8 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-extrabold text-brand-100"><span className="h-2 w-2 rounded-full bg-brand-300" /> {account?.site?.status || "PUBLISHED"}</span>
                <h2 className="mt-5 text-3xl font-black tracking-[-0.045em]">{account?.site?.businessName || "Website CSJW"}</h2>
                <p className="mt-2 text-sm text-white/60">Terhubung ke akun WhatsApp {account?.whatsapp}</p>
                <div className="mt-5 inline-flex max-w-full items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-semibold text-white/80"><Link2 size={16} className="shrink-0" /><span className="truncate">{siteUrl}</span></div>
              </div>
              <span className="grid h-24 w-24 place-items-center rounded-[1.75rem] border border-white/10 bg-white/10"><Globe2 size={42} /></span>
            </div>
          </div>
          <div className="grid gap-4 p-6 sm:grid-cols-3">
            {[
              ["Revision", String(account?.site?.revision || 1)],
              ["Paket", account?.planLabel || "Siap Profesional"],
              ["Update terakhir", account?.site?.lastUpdatedBy === "WHATSAPP" ? "Dari WhatsApp" : account?.site?.lastUpdatedBy === "DASHBOARD" ? "Dari Dashboard" : "Oleh sistem"],
            ].map(([label, value]) => <div key={label} className="rounded-2xl bg-slate-50 p-4"><p className="text-xs font-semibold text-slate-400">{label}</p><p className="mt-2 text-sm font-black text-slate-800">{value}</p></div>)}
          </div>
        </article>

        <article className="surface p-6">
          <div className="flex items-center justify-between"><div><h3 className="text-lg font-black text-slate-900">Akses cepat</h3><p className="mt-1 text-xs font-semibold text-slate-400">Bagikan dan kelola website</p></div><MoreHorizontal size={19} className="text-slate-400" /></div>
          <div className="mt-5 space-y-3">
            {[
              [Share2, "Bagikan ke WhatsApp", "Buat pesan siap kirim ke pelanggan"],
              [QrCode, "Unduh QR website", "Gunakan pada kemasan atau toko fisik"],
              [MonitorSmartphone, "Periksa responsive", "Lihat tampilan mobile, tablet, desktop"],
            ].map(([Icon, title, text]) => {
              const RowIcon = Icon as typeof Share2;
              return <button key={title as string} type="button" className="flex w-full items-center gap-3 rounded-2xl border border-slate-200 p-4 text-left hover:border-brand-200 hover:bg-brand-50/40"><span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-brand-50 text-brand-700"><RowIcon size={18} /></span><span><span className="block text-sm font-extrabold text-slate-800">{title as string}</span><span className="mt-0.5 block text-xs text-slate-400">{text as string}</span></span></button>;
            })}
          </div>
        </article>
      </section>

      <section className="grid gap-5 lg:grid-cols-3">
        {[
          ["Tampilan & section", "Atur tema, urutan section, headline, CTA, dan visibilitas.", "/dashboard/builder", "Buka builder"],
          ["Produk & katalog", "Produk pertama dari paket Free tetap ada. Tambahkan produk baru tanpa mengulang setup.", "/dashboard/products", "Kelola produk"],
          ["Domain & SEO", "Siapkan custom domain, title, description, dan social preview.", "/dashboard/settings", "Buka pengaturan"],
        ].map(([title, text, to, action]) => <article key={title} className="surface p-6"><h3 className="text-lg font-black text-slate-900">{title}</h3><p className="mt-3 min-h-16 text-sm leading-6 text-slate-500">{text}</p><Link className="mt-5 inline-flex items-center gap-2 text-sm font-extrabold text-brand-700" to={to}>{action} <ExternalLink size={14} /></Link></article>)}
      </section>
    </div>
  );
}
